import '../css/app.css';
import './echo';

import { createInertiaApp, Link } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import type { DefineComponent } from 'vue';
import { createApp, h } from 'vue';
import { ZiggyVue } from 'ziggy-js';
import CookieConsent from './components/landing/CookieConsent.vue';
import { initializeTheme } from './composables/useAppearance';
import { setupErrorHandler } from './utils/errorHandler';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
  title: (title) => (title ? `${appName} - ${title}` : appName),
  resolve: (name) => resolvePageComponent(`./pages/${name}.vue`, import.meta.glob<DefineComponent>('./pages/**/*.vue')),
  setup({ el, App, props, plugin }) {
    const app = createApp({
      render: () => h('div', [h(App, props), h(CookieConsent)]),
    });

    app.use(plugin).use(ZiggyVue).component('InertiaLink', Link);

    // Setup global error handler
    setupErrorHandler(app);

    app.mount(el);
  },
  progress: {
    color: '#4B5563',
  },
});

// This will set light / dark mode on page load...
initializeTheme();
